import { Box, Button, ButtonBase, Modal, Stack, Typography, useTheme } from '@mui/material'
import React from 'react';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import ScrollBox from '../../../components/ScrollBox';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';



function AddrPopupMdl({ modalOpen, handleMdlSave, handleModalClose, addrArr }) {
    const theme = useTheme();
    const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }

    function handleAddrClick(e) {
        handleMdlSave({ addr: e.addr })
    }

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {addrArr ? <form>
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={1}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Company Addresses</Typography>
                    </Stack>
                    {/* <Stack gap={2} alignItems="center">
                        <LabelTxtFieldInfo name="editRemarks" title="Notes" width={"100%"} borderRadius={1} rows={4} multiline={true} height={100} />
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}>  CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> SAVE</Button>
                        </Stack>
                    </Stack> */}
                    <Stack gap={2} alignItems="center">
                        <Typography sx={{ fontWeight: 600, fontSize: 14, color: "blue" }}>Select Dispatch Location</Typography>
                        <ScrollBox height={"80vh"} width={"100%"}>
                            {(addrArr || []).map((e, index) => (
                                <ButtonBase key={index} onClick={() => handleAddrClick(e)}>
                                    <Stack sx={{
                                        borderRadius: 1.4, gap: 2, mb: 0.5, px: 1, py: 0.5,
                                        backgroundColor: "rgba(162, 214, 249, 0.2)", width: "100%", position: "relative"
                                    }}>
                                        <CtrlLabelTxtFieldInfo name="addr" title={`Address: ${index + 1}`} placeholder={"Enter company address....."} {...txtFieldSx} width={"100%"} multiline={true}
                                            height={90} rows={5} value={e.addr} readOnly={true} />
                                    </Stack>
                                </ButtonBase>
                            ))}
                        </ScrollBox>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default AddrPopupMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};


